import * as React from 'react';
import { SVGProps } from 'react';

const SvgArrow45 = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.071 5.95 5.243 8.778h7.778l-6.01 6.01v4.243l8.132-8.132v7.778l2.829-2.828V5.95h-9.9z" />
  </svg>
);

export default SvgArrow45;
